export interface ApiGetTaskIdRequest {
    type: string;
}

export const GetTaskId = Symbol('ApiGetTaskId');

export interface GetTaskId {
    getTaskId(data: ApiGetTaskIdRequest): Promise<string>;
}
